module.exports = __webpack_public_path__ + "img/slk.5e6464e4.jpg";